import axios from "axios";
import moment from "moment"

export default {
    data(){
        return {
            backendExpertIndex: 'backend.expert.index',
            backendExpertView: 'backend.expert.view',
        }
    },
    methods: {
        formatDate(date) {
            return moment(date).format('DD MMM Y')
        },
        getCleanPhone(prefix, phone) {
            const result = parseInt(phone);

            return `${prefix}${result}`;
          },
        async getMyUser(){
            const response = await axios.get('/admin/me')
            return response.data
        },
        async getPermittedRoutes() {
            const response = await axios.get("/admin/permitted-routes");
            return response.data;
          },
        async getSingleWpMessage(str) {
            const response = await axios.post("/admin/get-translation", {
              translation: str,
            });
             return response.data;
          },
        async checkExpertUnsubscribeStatus(expertId) {
            try {
                const url = `/api/v1/expert/fetch-unsubscribe-status?expert_id=${expertId}`;
                const response = await axios.get(url);
                // Assumes the API returns { has_unsubscribed: true/false }
                return Boolean(response.data && response.data.data.is_unsubscribed);
            } catch (error) {
                return false;
            }
        }
    }
}
